import { SessionService } from 'services';

const { REACT_APP_API_URL_SERVICING } = process.env;

export class ApiServiceError extends Error {
  constructor(error) {
    super(error.message);
    this.statusCode = error.statusCode;
    this.timestamp = error.timestamp;
    this.path = error.timestamp;
    this.errors = error.errors;
    this.name = error.name;
    this.message = error.message;
  }
}

async function callApi({ path, method, headers = {}, body = null, queryParams }) {
  const url = new URL(REACT_APP_API_URL_SERVICING + path);
  url.search = new URLSearchParams(queryParams);

  const response = await fetch(url.toString(), {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  try {
    const returnBody = await response.json();
    if (!response.ok) throw new ApiServiceError(returnBody);
    return returnBody;
  } catch (e) {
    if (!response.ok) throw new ApiServiceError(e);
    return;
  }
}

async function callApiAuthenticated({ path, method, headers = {}, body = null, queryParams }) {
  // Can throw error when cognito token is expired ( or Error server )
  const accessToken = await SessionService.getToken();
  return callApi({
    path,
    method,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      ...headers,
    },
    body: body ? body : undefined,
    queryParams,
  });
}

export default {
  callApi,
  callApiAuthenticated,
};
